const URL_FORBIDDEN_WORDS = "/api/user/v1/portalUserForbiddenApi_listForbidden";

export const state = () => ( {
  forbiddenWords: []
} )

export const mutations = {
  SET_FORBIDDEN_WORDS( state, forbiddenWords ) {
    state.forbiddenWords = forbiddenWords;
  }
}

export const actions = {
  async getForbiddenWords( { commit } ) {

    const param = {};

    await $nuxt.$axios.post( URL_FORBIDDEN_WORDS, param ).then( res => {
      if ( $nuxt.$validate.isEmpty( res.data ) ) {
        return;
      }

      // 금칙어 객체에서 금칙어만 추출하여 배열로 만듭니다.
      const result = res.data.reduce(( ( acc, item ) => {
        if ( $nuxt.$validate.isNotEmpty( item.forbiddenWord ) ) {
          acc.push( item.forbiddenWord );
        }
        return acc;
      } ), [] );

      commit( "SET_FORBIDDEN_WORDS", result );
    } );
  }
}

export const getters = {
  forbiddenWords( state ) {
    return state.forbiddenWords;
  }
}
